'use strict';

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es6.object.freeze");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  margin-bottom:12px;\n  display: flex;\n  flex-direction:row;\n  justify-content: center;\n  @media (min-width: 960px){\n    top: 24px;\n    left: auto;\n    right: 24px;\n    justify-content: flex-end;\n  }\n'], ['\n  margin-bottom:12px;\n  display: flex;\n  flex-direction:row;\n  justify-content: center;\n  @media (min-width: 960px){\n    top: 24px;\n    left: auto;\n    right: 24px;\n    justify-content: flex-end;\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  transform: translate(0px, 0px);\n  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);\n  color: #fff;\n  display: flex;\n  padding: 6px 24px;\n  flex-wrap: wrap;\n  align-items: center;\n  background-color: ', ';\n  font-size: 0.875rem;\n  font-weight: 400;\n  font-family: "Roboto", "Helvetica", "Arial", sans-serif;\n  line-height: 1.46429em;\n  @media (min-width: 960px){\n    min-width: 288px;\n    max-width: 568px;\n    border-radius: 4px;\n  }\n  @media (max-width: 959.95px){\n    flex-grow: 1;\n  }\n  &::after{\n    content: \'\';\n    opacity: 0.2;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: #fff;\n    border-radius: 3px;\n    animation: animate-shine ', ' ease-out infinite;\n    animation-iteration-count:1;\n  }\n  @keyframes animate-shine\n  {\n    from {right:100%;}\n    to {right:0;}\n  }\n'], ['\n  transform: translate(0px, 0px);\n  transition: transform 225ms cubic-bezier(0, 0, 0.2, 1) 0ms;\n  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);\n  color: #fff;\n  display: flex;\n  padding: 6px 24px;\n  flex-wrap: wrap;\n  align-items: center;\n  background-color: ', ';\n  font-size: 0.875rem;\n  font-weight: 400;\n  font-family: "Roboto", "Helvetica", "Arial", sans-serif;\n  line-height: 1.46429em;\n  @media (min-width: 960px){\n    min-width: 288px;\n    max-width: 568px;\n    border-radius: 4px;\n  }\n  @media (max-width: 959.95px){\n    flex-grow: 1;\n  }\n  &::after{\n    content: \'\';\n    opacity: 0.2;\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background: #fff;\n    border-radius: 3px;\n    animation: animate-shine ', ' ease-out infinite;\n    animation-iteration-count:1;\n  }\n  @keyframes animate-shine\n  {\n    from {right:100%;}\n    to {right:0;}\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  max-width:88%;\n  padding: 8px 0;\n'], ['\n  max-width:88%;\n  padding: 8px 0;\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  white-space: pre-line;\n'], ['\n  display: flex;\n  align-items: center;\n  white-space: pre-line;\n']),
    _templateObject5 = _taggedTemplateLiteral(["\n  display: -webkit-box;\n  word-break: break-all;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3; //\u9700\u8981\u663E\u793A\u7684\u884C\u6570\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  display: -webkit-box;\n  word-break: break-all;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 3; //\u9700\u8981\u663E\u793A\u7684\u884C\u6570\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]),
    _templateObject6 = _taggedTemplateLiteral(['\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n  margin-right: -8px;\n'], ['\n  display: flex;\n  align-items: center;\n  margin-left: auto;\n  margin-right: -8px;\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n  color:white;\n  flex: 0 0 auto;\n  width:44px;\n  height:44px;\n  padding: 12px;\n  overflow: visible;\n  font-size: 1.5rem;\n  text-align: center;\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  border-radius: 50%;\n  margin: 0;\n  cursor: pointer;\n  display: inline-flex;\n  outline: none;\n  padding: 0;\n  position: relative;\n  align-items: center;\n  user-select: none;\n  vertical-align: middle;\n  justify-content: center;\n  -moz-appearance: none;\n  text-decoration: none;\n  background-color: transparent;\n  -webkit-appearance: none;\n  -webkit-tap-highlight-color: transparent;\n  &:hover{\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n'], ['\n  color:white;\n  flex: 0 0 auto;\n  width:44px;\n  height:44px;\n  padding: 12px;\n  overflow: visible;\n  font-size: 1.5rem;\n  text-align: center;\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n  border-radius: 50%;\n  margin: 0;\n  cursor: pointer;\n  display: inline-flex;\n  outline: none;\n  padding: 0;\n  position: relative;\n  align-items: center;\n  user-select: none;\n  vertical-align: middle;\n  justify-content: center;\n  -moz-appearance: none;\n  text-decoration: none;\n  background-color: transparent;\n  -webkit-appearance: none;\n  -webkit-tap-highlight-color: transparent;\n  &:hover{\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Icon = require('./Icon');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Toast = function (_Component) {
  _inherits(Toast, _Component);

  function Toast(props) {
    _classCallCheck(this, Toast);

    var _this = _possibleConstructorReturn(this, (Toast.__proto__ || Object.getPrototypeOf(Toast)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(Toast, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          type = _props.type,
          closable = _props.closable,
          duration = _props.duration,
          children = _props.children;
      return _react2["default"].createElement(ToastGroup, null, _react2["default"].createElement(ToastConent, {
        type: type,
        duration: duration
      }, _react2["default"].createElement(Message, null, _react2["default"].createElement(MessageSpan, null, _react2["default"].createElement(_Icon.TypeIcon, {
        type: type
      }), _react2["default"].createElement(MessageText, null, children))), closable ? _react2["default"].createElement(CloseContent, {
        onClick: this.props.onClose
      }, _react2["default"].createElement(ClostButton, null, _react2["default"].createElement(_Icon.CloseIcon, null))) : null));
    }
  }]);

  return Toast;
}(_react.Component);

Toast.propTypes = {
  type: _propTypes2["default"].oneOf(['success', 'error', 'info', 'warning']),
  closable: _propTypes2["default"].bool
};
exports["default"] = Toast;

var ToastGroup = _styledComponents2["default"].div(_templateObject);

var ToastConent = _styledComponents2["default"].div(_templateObject2, function (props) {
  return getColor(props.type);
}, function (props) {
  return getTimes(props.duration);
});

var getTimes = function getTimes(duration) {
  return duration + 0.5 + 's';
};

var getColor = function getColor(type) {
  switch (type) {
    case 'success':
      return '#43a047';

    case 'error':
      return '#d32f2f';

    case 'warning':
      return '#ffa000';

    case 'info':
      return '#303f9f';

    default:
      return '#43a047';
  }
};

var Message = _styledComponents2["default"].div(_templateObject3);

var MessageSpan = _styledComponents2["default"].span(_templateObject4);

var MessageText = _styledComponents2["default"].div(_templateObject5);

var CloseContent = _styledComponents2["default"].div(_templateObject6);

var ClostButton = _styledComponents2["default"].div(_templateObject7);